const errorType = {
    ERROR: 'ERROR',
    SET_NOTIFICATION: "SET_NOTIFICATION",
    CONFIRM_ERROR: 'CONFIRM_ERROR',
    SET_CONFIRM_ERROR: 'SET_CONFIRM_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',

}

export default errorType;